import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import historyReducer from '../histori/HistoriSlice';
import team1Reducer from '../teams/Team1Slice';
import team2Reducer from '../teams/Team2Slice';
import teamsReducer from '../teams/TeamSlice';
import { combineReducers } from 'redux';
import logger from 'redux-logger';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['history', 'team1', 'team2', 'teams'],
};

const rootReducer = combineReducers({
    history: historyReducer,
    team1: team1Reducer,
    team2: team2Reducer,
    teams: teamsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(logger),
});

export const persistor = persistStore(store);
export default store;
